// File: src/components/layouts/helpers/OverflowWrapper/OverflowWrapper.tsx
// Purpose: Layout or container component

import React from "react";
import styled from "styled-components";

interface OverflowWrapperProps {
  children: React.ReactNode;
  maxHeight?: string;
  maxWidth?: string;
  direction?: "horizontal" | "vertical" | "both";
  hideScrollbar?: boolean;
}

const StyledOverflowWrapper = styled.div<OverflowWrapperProps>`
  max-height: ${({ maxHeight }) => maxHeight || "100%"};
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  overflow-x: ${({ direction }) =>
    direction === "horizontal" || direction === "both" ? "auto" : "hidden"};
  overflow-y: ${({ direction }) =>
    direction === "vertical" || direction === "both" ? "auto" : "hidden"};

  ${({ hideScrollbar }) =>
    hideScrollbar &&
    `
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  `}

  border-radius: ${({ theme }) => theme.radii.md};
  background: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) => theme.spacing.sm};
`;

export const OverflowWrapper: React.FC<OverflowWrapperProps> = ({
  children,
  maxHeight,
  maxWidth,
  direction = "both",
  hideScrollbar = false,
}) => {
  return (
    <StyledOverflowWrapper
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      direction={direction}
      hideScrollbar={hideScrollbar}
    >
      {children}
    </StyledOverflowWrapper>
  );
};